import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { Caracteristicas } from "../interfaces/Caracteristicas";

export type AtualizarCaracteristicaPayload = Pick<
  Caracteristicas,
  "id" | "nome" | "escopo" | "active"
>;

export const atualizarCaracteristicaService = async (
  data: AtualizarCaracteristicaPayload
) => {
  const Token = validateToken();

  if (!Token) return false;

  const headers = { Authorization: Token.AuthStr };
  const payload = {
    id: data.id,
    nome: data.nome,
    escopo: data.escopo || "AMBOS",
    active: data.active ?? 1,
  };

  try {
    const response = await axios.put(
      `${Globais.DOMINIOBACK}/caracteristicas/${data.id}`,
      payload,
      {
        headers,
      }
    );

    return response?.data || true;
  } catch (error) {
    console.error(error);

    try {
      const response = await axios.put(
        `${Globais.DOMINIOBACK}/caracteristicas`,
        payload,
        {
          headers,
        }
      );

      return response?.data || true;
    } catch (fallbackError) {
      console.error(fallbackError);

      try {
        const response = await axios.patch(
          `${Globais.DOMINIOBACK}/caracteristicas/${data.id}`,
          payload,
          {
            headers,
          }
        );

        return response?.data || true;
      } catch (patchError) {
        console.error(patchError);
        return false;
      }
    }
  }
};
